// extracted by mini-css-extract-plugin
export default {"inlineLabel":"label-module--inline-label--54098","labelText":"label-module--label-text--c868d"};